import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { getApplicationSpaBackendUrl } from "@utils";
import { type IUserInfo, type IUserInfoResponse } from "@types";

export const USER_INFO_API_REDUCER_KEY = "userInfoApi";
export const userInfoApi = createApi({
  reducerPath: USER_INFO_API_REDUCER_KEY,
  baseQuery: (arguments_, api, extraOptions) =>
    baseQueryWithAuth({ baseUrl: getApplicationSpaBackendUrl() })(arguments_, api, {
      ...extraOptions,
      isExternalService: true,
    }),
  endpoints: (builder) => ({
    postUserInfo: builder.mutation<IUserInfoResponse, IUserInfo>({
      query: (body) => ({
        url: "/user-info",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { usePostUserInfoMutation } = userInfoApi;
